import { useGetApiV1SerievideoVideoidLangsAvailableLanguages } from '@/shared/api/generated';

/**
 * Hook para obter os idiomas ainda não cadastrados para um Vídeo (alimenta o
 * `SelectInput` de Idioma na tela de criação de Idioma do Vídeo).
 *
 * Envolve o hook gerado pelo Kubb para
 * `GET /api/v1/serievideo/{videoId}/langs/available-languages`.
 *
 * @param videoId - ID do vídeo
 *
 * @example
 * ```tsx
 * const { options } = useAvailableSerieVideoLanguages(videoId);
 * ```
 */
export function useAvailableSerieVideoLanguages(videoId: number) {
  const { data, isLoading } = useGetApiV1SerievideoVideoidLangsAvailableLanguages(videoId);

  return { options: data ?? [], isLoading } as const;
}
